export const LIST_REGION = 'LIST_REGION'
export const LIST_REGION_PENDING = `${LIST_REGION}_PENDING`
export const LIST_REGION_FULFILLED = `${LIST_REGION}_FULFILLED`
export const LIST_REGION_REJECTED = `${LIST_REGION}_REJECTED`

export const LIST_DEPARTMENTS_REGION = 'LIST_DEPARTMENTS_REGION'
export const LIST_DEPARTMENTS_REGION_PENDING = `${LIST_DEPARTMENTS_REGION}_PENDING`
export const LIST_DEPARTMENTS_REGION_FULFILLED = `${LIST_DEPARTMENTS_REGION}_FULFILLED`
export const LIST_DEPARTMENTS_REGION_REJECTED = `${LIST_DEPARTMENTS_REGION}_REJECTED`

export const LIST_SPECIALTY_SKILL = 'LIST_SPECIALTY_SKILL'
export const LIST_SPECIALTY_SKILL_PENDING = `${LIST_SPECIALTY_SKILL}_PENDING`
export const LIST_SPECIALTY_SKILL_FULFILLED = `${LIST_SPECIALTY_SKILL}_FULFILLED`
export const LIST_SPECIALTY_SKILL_REJECTED = `${LIST_SPECIALTY_SKILL}_REJECTED`

export const LIST_EQUIPMENTS = 'LIST_EQUIPMENTS'
export const LIST_EQUIPMENTS_PENDING = `${LIST_EQUIPMENTS}_PENDING`
export const LIST_EQUIPMENTS_FULFILLED = `${LIST_EQUIPMENTS}_FULFILLED`
export const LIST_EQUIPMENTS_REJECTED = `${LIST_EQUIPMENTS}_REJECTED`

export const DATA_NEW_LEAD = 'DATA_NEW_LEAD'
export const DATA_NEW_LEAD_PENDING = `${DATA_NEW_LEAD}_PENDING`
export const DATA_NEW_LEAD_FULFILLED = `${DATA_NEW_LEAD}_FULFILLED`
export const DATA_NEW_LEAD_REJECTED = `${DATA_NEW_LEAD}_REJECTED`

export const DATA_NEW_PROVIDER = 'DATA_NEW_PROVIDER'
export const DATA_NEW_PROVIDER_PENDING = `${DATA_NEW_PROVIDER}_PENDING`
export const DATA_NEW_PROVIDER_FULFILLED = `${DATA_NEW_PROVIDER}_FULFILLED`
export const DATA_NEW_PROVIDER_REJECTED = `${DATA_NEW_PROVIDER}_REJECTED`

export const DATA_NEW_TASK = 'DATA_NEW_TASK'
export const DATA_NEW_TASK_PENDING = `${DATA_NEW_TASK}_PENDING`
export const DATA_NEW_TASK_FULFILLED = `${DATA_NEW_TASK}_FULFILLED`
export const DATA_NEW_TASK_REJECTED = `${DATA_NEW_TASK}_REJECTED`

export const LIST_DEPARTMENTS = 'LIST_DEPARTMENTS'
export const LIST_DEPARTMENTS_PENDING = `${LIST_DEPARTMENTS}_PENDING`
export const LIST_DEPARTMENTS_FULFILLED = `${LIST_DEPARTMENTS}_FULFILLED`
export const LIST_DEPARTMENTS_REJECTED = `${LIST_DEPARTMENTS}_REJECTED`



// WEBPACK FOOTER //
// ./src/datas/DatasConstants.js